module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('div', {
    staticStyle: {
      "position": "relative",
      "height": "100%",
      "width": "100%"
    }
  }, [_c('transition-group', {
    attrs: {
      "name": "x-slow-fade"
    }
  }, [(_vm.imageNumber == 1) ? _c('img', {
    key: "img1",
    staticClass: "round white-border shadow absolute",
    attrs: {
      "width": "100%",
      "height": "100%",
      "src": _vm.src1,
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.imageNumber == 2) ? _c('img', {
    key: "img2",
    staticClass: "round white-border shadow absolute",
    attrs: {
      "width": "100%",
      "height": "100%",
      "src": _vm.src2,
      "alt": ""
    }
  }) : _vm._e()])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0825d48c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui-elements/ImageFader.vue
// module id = 2440
// module chunks = 1